import type { Branch } from '../types/branch'
import { api } from './index'

export const getBranches = ({ id }: { id: string }) => api.get<{
  name: string,
  branches: Branch[]
}>('/contests/branches', {
  params: {
    token: id
  }
});

export const getRanking = ({ id, branch_id, token }: { id?: string, branch_id: string, token?: string }) => api.get<{
  interval: string,
  start: string,
  end: string,
  branch_name: string,
  brand_name: string,
  contest: {
    show_daypart: boolean,
    realtime_sections: string[],
    third_party_sources: string[],
    layout: "counter" | "drivethru",
    table_time_frame_title: ("current_daypart" | "current_day" | "current_hour")[],
    table_metric_title: ("cars" | "lane_total" | "goal_meet_percentage")[]
  },
  type: (
    "dayparts_queue" | 
    "dayparts_service" | 
    "dayparts_production_count" | 
    "dayparts_total_service" | 
    "dayparts_service_goal" | 
    "dayparts_service_goal_meet_percentage" | 
    "dayparts_service_goal_color" |
    "1day_queue" | 
    "1day_service" |
    "1day_production_count" | 
    "1day_total_service" | 
    "1day_service_goal" | 
    "1day_service_goal_meet_percentage" | 
    "1day_service_goal_color" |
    "rolling_hour_total_service"
  )[],
  rows: {
    rank: number,
    branch_id: string,
    branch_name: string,
    data: { [key: string]: number }
  }[],
  summary_rows: {
    type: "dayparts_queue" | "dayparts_service",
    goal: number,
    value: number,
    color: "G" | "O" | "R" | null,
    sample_size_threshold: number | null,
  }[]
    }>(`/contests/leaderboard/${branch_id}`, {
      headers: {
        "Accept-Version": "1",
        Authorization: token ? `Bearer ${token}` : null,
      },
      params: {
        token: id ? id : null
      } 
    });

export const getRealtime = ({ id, branch_id, token }: { id?: string, branch_id: string, token?: string }) => api.get<{
  rows: {
    type: string,
    goal: number,
    value: string | null,
    color: "G" | "O" | "R" | null
  }[]
}>(`/contests/leaderboard/${branch_id}/realtime`, {
  headers: {
    Authorization: token ? `Bearer ${token}` : null,
  },
  params: {
    token: id ? id : null
  }
})

export const apiStreamings = {
  getBranches,
  getRanking,
  getRealtime
};

export default apiStreamings;
